module.exports = __webpack_public_path__ + "static/img/error.87e74e25.png";